import React from 'react';

const GameWheel = ({ style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.8555 4.25781C19.9235 5.96549 22 9.2396 22 13C22 18.5228 17.5228 23 12 23C6.47717 23 2.00004 18.5228 2 13C2 9.27364 4.03915 6.02495 7.06152 4.30469L12 11.6406L13.5322 9.31152L16.0342 5.5166C16.0325 5.51571 16.031 5.51457 16.0293 5.51367L16.8555 4.25781ZM7.9668 20.4824C9.16699 21.1307 10.5402 21.5 12 21.5C13.4598 21.5 14.833 21.1307 16.0332 20.4824L12 14.3633L7.9668 20.4824ZM3.53516 13.75C3.7441 16.1391 4.94046 18.2431 6.71484 19.6543L10.6074 13.75H3.53516ZM17.2842 19.6543C19.0589 18.2431 20.2559 16.1393 20.4648 13.75H13.3926L17.2842 19.6543ZM6.71484 6.34473C4.9402 7.75592 3.7441 9.8607 3.53516 12.25H10.6074L6.71484 6.34473ZM13.3926 12.25H20.4648C20.2559 9.86043 19.0592 7.75593 17.2842 6.34473L13.3926 12.25ZM12.624 5.41602L12 6.35254L11.376 5.41602L8.59863 1.25H15.4014L12.624 5.41602Z",
      fill: "white"
    }
  )
);

export { GameWheel };
//# sourceMappingURL=GameWheel.js.map
